export const INCREMENT_INTERACTIONS = 'tagging/INCREMENT_INTERACTIONS';

export const RESET_TAGGING = 'tagging/RESET_TAGGING';
